import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { wishlistService } from '../services/wishlist.service';
import { queryKeys } from './query-keys';
import { Product } from '../entities/product.entity';

export function useWishlist() {
  return useQuery({
    queryKey: queryKeys.wishlist.current(),
    queryFn: () => wishlistService.getWishlist(),
  });
}

export function useAddToWishlist() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (product: Product) => wishlistService.addToWishlist(product.id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.wishlist.current() });
    },
  });
}

export function useRemoveFromWishlist() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (productId: string) => wishlistService.removeFromWishlist(productId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.wishlist.current() });
    },
  });
}

export function useClearWishlist() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => wishlistService.clearWishlist(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.wishlist.current() });
    },
  });
}
